import {FC, useEffect, useState} from "react";
import Script from "next/script";

interface AppTrackingProps {
}


const AppTracking: FC<AppTrackingProps> = (props) => {

	const [preferencesConsentGive, setPreferencesConsentGive] = useState(false);
	const [statisticsConsentGiven, setStatisticsConsentGiven] = useState(false);
	const [marketingConsentGiven, setMarektingConsentGiven] = useState(false);

	const [googleTagManager, setGoogleTagManager] = useState<JSX.Element | null>(null);

	useEffect(() => {
		const checkConsent = () => {
			if (typeof Cookiebot !== "undefined") {
				setPreferencesConsentGive(!!Cookiebot?.consent?.preferences);
				setStatisticsConsentGiven(!!Cookiebot?.consent?.statistics);
				setMarektingConsentGiven(!!Cookiebot?.consent?.marketing);
			}
		};

		checkConsent();

		window.addEventListener("CookiebotOnAccept", checkConsent, false);
		window.addEventListener("CookiebotOnDecline", checkConsent, false);

		return () => {
			window.removeEventListener("CookiebotOnAccept", checkConsent);
			window.removeEventListener("CookiebotOnDecline", checkConsent);
		};
	}, []);

	/* useEffect(() => {
	  if (typeof _Focal !== "undefined") {
		if (statisticsConsentGiven) {
		  _Focal._setCookie();
		} else {
		  _Focal._setCookie(-1);
		}
	  }
	}, [statisticsConsentGiven]); */

	useEffect(() => {
		if (preferencesConsentGive) {
			setGoogleTagManager(
				<>
					<Script id="google-tag-manager">{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-W9BJX9G');`}</Script>
					<noscript>
						<iframe
							src="https://www.googletagmanager.com/ns.html?id=GTM-W9BJX9G"
							height="0"
							width="0"
							style={{display: "none", visibility: "hidden"}}
						/>
					</noscript>
				</>
			);
		} else {
			setGoogleTagManager(<></>);
		}
	}, [preferencesConsentGive]);

	return (
		<>
			{/* {typeof _Focal === "undefined" &&
      <Script id="focal" type="text/javascript">
         {`window._FocalQueue = window._FocalQueue || [];
(function(c,i) {
var t =  "https://ws.focal-analytics.de/t/";
var fc=(c.match(new RegExp('(^| )_focal_fptc=([^;]+)'))||[0,0,false])[2];
var focalQueryString = "?y="+screen.height.toString()+"&u="+encodeURIComponent(window.location.href);
if(fc) focalQueryString+="&p="+fc;
if(document.referrer != ""){ focalQueryString += '&r=' + encodeURIComponent(document.referrer);}
var focalScript = document.createElement("script"); focalScript.src = t+i+"/"+screen.width.toString()+focalQueryString;
focalScript.async = true; focalScript.type = "text/javascript";
document.getElementsByTagName("head")[0].appendChild(focalScript);
})(document.cookie,60);`}
      </Script>} */}

			{googleTagManager}
		</>
	);
};

export default AppTracking;
